const { fetchAuthorizedJsonApi } = require('./abstract');
const { apiUrls } = require('./apiUrls');

const fetchPlayer = (token, id, type) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'GET',
    endpoint: `users/${id}`,
    query: { type },
    expectedStatus: 200,
    description: 'Get requested user',
  });

const fetchFriends = (token) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'GET',
    endpoint: 'friends',
    expectedStatus: 200,
    description: 'Get list of friends',
  });

const fetchInvitations = (token) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'GET',
    endpoint: 'friends/invites',
    expectedStatus: 200,
    description: 'Get list of friend invitations',
  });

const inviteFriend = (token, uid) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'POST',
    endpoint: 'friends/invites',
    body: { uid },
    expectedStatus: 200,
    description: 'Send friend invite to user',
  });

const reportUser = (token, reportBody) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'POST',
    endpoint: 'reports',
    body: reportBody,
    expectedStatus: 204,
    description: 'Report User',
  });

const acceptInvitation = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: `friends/invites/${id}/accept`,
    expectedStatus: 200,
    description: 'Accept invitation',
  });

const rejectInvitation = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: `friends/invites/${id}/reject`,
    expectedStatus: 204,
    description: 'Reject invitation',
  });

function deleteInvitation(token, id) {
  return fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'DELETE',
    endpoint: `friends/invites/${id}`,
    expectedStatus: 204,
    description: 'Delete invitation',
  });
}

const blockFriend = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: `friends/${id}/block`,
    expectedStatus: 204,
    description: 'Block friend',
  });

const unblockFriend = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: `friends/${id}/unblock`,
    expectedStatus: 204,
    description: 'Unblock friend',
  });

const deleteFriend = (token, id) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'DELETE',
    endpoint: `friends/${id}`,
    expectedStatus: 204,
    description: 'Delete friend',
  });

const acknowledgeEntry = (token, friends = [], invites = []) =>
  fetchAuthorizedJsonApi({
    apiUrl: apiUrls.RADAR_API_URL,
    token,
    method: 'PUT',
    endpoint: 'friends/acknowledge',
    body: { friends, invites },
    expectedStatus: 204,
    description: 'Mark friends and invitations as acknowledged',
  });

module.exports = {
  fetchPlayer,
  fetchFriends,
  inviteFriend,
  reportUser,
  blockFriend,
  unblockFriend,
  deleteFriend,
  fetchInvitations,
  acceptInvitation,
  rejectInvitation,
  deleteInvitation,
  acknowledgeEntry,
};
